import { ScreenNames } from '~types/index'

const getCurrentScreen = (
  currentPath: string[],
  currentScreenName: ScreenNames,
  first?: boolean
): ScreenNames => {
  const defaultScreenName: ScreenNames = {}

  if (!currentPath.length) {
    const screenName = first ? defaultScreenName : currentScreenName
    return screenName
  }

  const [currentKey, ...remainingPath] = currentPath
  const foundScreenName =
    currentScreenName?.[`/${currentKey}` as keyof ScreenNames]

  if (!foundScreenName) {
    const screenName = first ? defaultScreenName : currentScreenName
    return screenName
  }

  return getCurrentScreen(remainingPath, foundScreenName)
}

export { getCurrentScreen }
